import api from '../../services/api';

const urlBase = '/viagens';

export default {
	listar: (params = {}) =>
		api.get(urlBase, { params }),

	criar: (data) =>
		api.post(urlBase, data),

	atualizar: (viagemId, data) =>
		api.put(`${urlBase}/${viagemId}`, data),

	atualizarStatus: (viagemId, status) =>
		api.put(`${urlBase}/${viagemId}/status`, { status }),

	excluir: (viagemId) =>
		api.delete(`${urlBase}/${viagemId}`),

	buscarPorId: (viagemId) =>
		api.get(`${urlBase}/${viagemId}`).then((res) => res.data),

	listarDespesas: (viagemId) =>
		api.get(`${urlBase}/${viagemId}/despesas`).then((res) => res.data),

	criarDespesa: (viagemId, data) =>
		api.post(`${urlBase}/${viagemId}/despesas`, data),

	atualizarDespesa: (viagemId, despesaId, data) =>
		api.put(`${urlBase}/${viagemId}/despesas/${despesaId}`, data),

	excluirDespesa: (viagemId, despesaId) =>
		api.delete(`${urlBase}/${viagemId}/despesas/${despesaId}`),
};
